var _desc, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 276,
    height: 120,
    viewBox: "0 0 276 120",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.3.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 138.1239118456 60)",
    id: "WIFJVRWtHa-365GSulusc"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0210689951 0 0 1.0210689951 -97.7187005609 -28.7609087221)",
    id: "ZsSznPaba6nK06i7_N9XI"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(192,182,186)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -28.12148 C 15.52306 -28.12148 28.12148 -15.523049999999998 28.12148 0 C 28.12148 15.52306 15.523049999999998 28.12148 0 28.12148 C -15.52306 28.12148 -28.12148 15.523049999999998 -28.12148 0 C -28.12148 -15.52306 -15.523049999999998 -28.12148 0 -28.12148 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.387500876 0 0 0.387500876 -123.2043303431 -3.4222150391)",
    id: "x1FFsJFAhNxPXdHYM6p4U"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(192,182,186)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -28.12148 C 15.52306 -28.12148 28.12148 -15.523049999999998 28.12148 0 C 28.12148 15.52306 15.523049999999998 28.12148 0 28.12148 C -15.52306 28.12148 -28.12148 15.523049999999998 -28.12148 0 C -28.12148 -15.52306 -15.523049999999998 -28.12148 0 -28.12148 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5002149338 0 0 0.5002149338 -102.3658901355 43.4080982967)",
    id: "Eez7TBpwrj4FcmRhGU0ap"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(192,182,186)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -28.12148 C 15.52306 -28.12148 28.12148 -15.523049999999998 28.12148 0 C 28.12148 15.52306 15.523049999999998 28.12148 0 28.12148 C -15.52306 28.12148 -28.12148 15.523049999999998 -28.12148 0 C -28.12148 -15.52306 -15.523049999999998 -28.12148 0 -28.12148 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.3641317137 -0.1325331051 0.3476520657 0.9551662002 -114.442156457 20.6711533913)",
    id: "dNmaWXC_0E4WPEKPI9oeZ"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(103,233,191)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -28.12148 -23.57313 C -28.12148 -26.08512 -22.779819999999997 -28.12148 -16.19054 -28.12148 L 16.190560000000005 -28.12148 L 16.190560000000005 -28.12148 C 22.779830000000004 -28.12148 28.121500000000005 -26.08511 28.121500000000005 -23.57313 L 28.121500000000005 23.573140000000002 L 28.121500000000005 23.573140000000002 C 28.121500000000005 26.085130000000003 22.779840000000004 28.12149 16.190560000000005 28.12149 L -16.19054 28.12149 L -16.19054 28.12149 C -22.779809999999998 28.12149 -28.12148 26.085120000000003 -28.12148 23.573140000000002 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.3212527856 0.2166877399 -0.7615798218 1.1290885182 -79.6876090511 15.9713825894)",
    id: "KMT7n5uKS5ioQV3fnSp7D"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(103,233,191)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -28.12148 -24.72685 C -28.12148 -26.60166 -22.779819999999997 -28.121489999999998 -16.19054 -28.121489999999998 L 16.190560000000005 -28.121489999999998 L 16.190560000000005 -28.121489999999998 C 22.779830000000004 -28.121489999999998 28.121500000000005 -26.60166 28.121500000000005 -24.72685 L 28.121500000000005 24.726840000000003 L 28.121500000000005 24.726840000000003 C 28.121500000000005 26.601650000000003 22.779840000000004 28.121480000000002 16.190560000000005 28.121480000000002 L -16.19054 28.121480000000002 L -16.19054 28.121480000000002 C -22.779809999999998 28.121480000000002 -28.12148 26.601650000000003 -28.12148 24.726840000000003 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.3212527856 0.2166877399 -0.5678394237 0.841856566 38.5647301364 11.7421614371)",
    id: "XLJFUDfRj3XrseZ-KuBYq"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(103,233,191)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -28.12148 -23.56864 C -28.12148 -26.083109999999998 -22.779819999999997 -28.121489999999998 -16.19054 -28.121489999999998 L 16.190560000000005 -28.121489999999998 L 16.190560000000005 -28.121489999999998 C 22.779830000000004 -28.121489999999998 28.121500000000005 -26.083109999999998 28.121500000000005 -23.56864 L 28.121500000000005 23.568630000000002 L 28.121500000000005 23.568630000000002 C 28.121500000000005 26.0831 22.779840000000004 28.121480000000002 16.190560000000005 28.121480000000002 L -16.19054 28.121480000000002 L -16.19054 28.121480000000002 C -22.779809999999998 28.121480000000002 -28.12148 26.0831 -28.12148 23.568630000000002 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.4524904901 0.7530706386 -1.5476011245 -0.9298925697 -24.7083172622 5.6862712973)",
    id: "JJ25nhKBxvWpYYYH2cO8T"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(103,233,191)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -28.12148 -25.56219 C -28.12148 -26.97565 -25.76672 -28.12149 -22.86199 -28.12149 L 22.86199 -28.12149 L 22.86199 -28.12149 C 25.76673 -28.12149 28.12148 -26.97565 28.12148 -25.56219 L 28.12148 25.56219 L 28.12148 25.56219 C 28.12148 26.97565 25.76672 28.12149 22.86199 28.12149 L -22.86199 28.12149 L -22.86199 28.12149 C -25.76673 28.12149 -28.12148 26.97565 -28.12148 25.56219 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.38729285 -2.2421412104 0 63.5673232002 40.615857557)",
    id: "DBmjSM4XySUBvlAaghMhG"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(103,233,191)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -28.12148 -26.06061 C -28.12148 -27.198800000000002 -22.779819999999997 -28.121480000000002 -16.19054 -28.121480000000002 L 16.190560000000005 -28.121480000000002 L 16.190560000000005 -28.121480000000002 C 22.779830000000004 -28.121480000000002 28.121500000000005 -27.198800000000002 28.121500000000005 -26.06061 L 28.121500000000005 26.060619999999997 L 28.121500000000005 26.060619999999997 C 28.121500000000005 27.198809999999998 22.779840000000004 28.121489999999998 16.190560000000005 28.121489999999998 L -16.19054 28.121489999999998 L -16.19054 28.121489999999998 C -22.779809999999998 28.121489999999998 -28.12148 27.198809999999998 -28.12148 26.060619999999997 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.2489470865 0.2966835847 -0.8678707891 -0.7282300591 74.9739001305 7.2969784306)",
    id: "tHjuq8MVahDnXWZAH2T0C"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(103,233,191)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -28.12148 -24.04287 C -28.12148 -26.29543 -22.779819999999997 -28.12149 -16.19054 -28.12149 L 16.190560000000005 -28.12149 L 16.190560000000005 -28.12149 C 22.779830000000004 -28.12149 28.121500000000005 -26.295430000000003 28.121500000000005 -24.04287 L 28.121500000000005 24.04287 L 28.121500000000005 24.04287 C 28.121500000000005 26.29543 22.779840000000004 28.12149 16.190560000000005 28.12149 L -16.19054 28.12149 L -16.19054 28.12149 C -22.779809999999998 28.12149 -28.12148 26.295430000000003 -28.12148 24.04287 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0337548016 0.3858191476 -1.7217703121 -0.1506353835 1.5400417737 -31.8305720733)",
    id: "59CE3appKf8I88el6VcBb"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(103,233,191)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -28.12148 -25.44797 C -28.12148 -26.92451 -22.779819999999997 -28.12149 -16.19054 -28.12149 L 16.190560000000005 -28.12149 L 16.190560000000005 -28.12149 C 22.779830000000004 -28.12149 28.121500000000005 -26.92452 28.121500000000005 -25.44797 L 28.121500000000005 25.44796 L 28.121500000000005 25.44796 C 28.121500000000005 26.9245 22.779840000000004 28.12148 16.190560000000005 28.12148 L -16.19054 28.12148 L -16.19054 28.12148 C -22.779809999999998 28.12148 -28.12148 26.924509999999998 -28.12148 25.44796 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5671084609 0 0 0.5237513809 -43.0319148143 -31.9601841986)",
    id: "SbwGWFNx2kStl5ZtbrEJT"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(192,182,186)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -28.12148 C 15.52306 -28.12148 28.12148 -15.523049999999998 28.12148 0 C 28.12148 15.52306 15.523049999999998 28.12148 0 28.12148 C -15.52306 28.12148 -28.12148 15.523049999999998 -28.12148 0 C -28.12148 -15.52306 -15.523049999999998 -28.12148 0 -28.12148 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.387500876 0 0 0.387500876 53.4644213346 -10.8293895048)",
    id: "q4We-TcANK9bKmNsi-kh_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(192,182,186)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -28.12148 C 15.52306 -28.12148 28.12148 -15.523049999999998 28.12148 0 C 28.12148 15.52306 15.523049999999998 28.12148 0 28.12148 C -15.52306 28.12148 -28.12148 15.523049999999998 -28.12148 0 C -28.12148 -15.52306 -15.523049999999998 -28.12148 0 -28.12148 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.38729285 0 0 0.38729285 44.4585732002 -28.1384538359)",
    id: "Cfo5qu2AFp_AihlsN2ntJ"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(192,182,186)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -28.12148 C 15.52306 -28.12148 28.12148 -15.523049999999998 28.12148 0 C 28.12148 15.52306 15.523049999999998 28.12148 0 28.12148 C -15.52306 28.12148 -28.12148 15.523049999999998 -28.12148 0 C -28.12148 -15.52306 -15.523049999999998 -28.12148 0 -28.12148 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.38729285 0 0 0.38729285 94.4585713356 23.4900993131)",
    id: "h4tUdlJI0noOo8sJsPQZk"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(192,182,186)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -28.12148 C 15.52306 -28.12148 28.12148 -15.523049999999998 28.12148 0 C 28.12148 15.52306 15.523049999999998 28.12148 0 28.12148 C -15.52306 28.12148 -28.12148 15.523049999999998 -28.12148 0 C -28.12148 -15.52306 -15.523049999999998 -28.12148 0 -28.12148 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.38729285 0 0 0.38729285 123.5673232002 40.7288396664)",
    id: "qgbIgxseu5yghkVhSW6_P"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(192,182,186)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -28.12148 C 15.52306 -28.12148 28.12148 -15.523049999999998 28.12148 0 C 28.12148 15.52306 15.523049999999998 28.12148 0 28.12148 C -15.52306 28.12148 -28.12148 15.523049999999998 -28.12148 0 C -28.12148 -15.52306 -15.523049999999998 -28.12148 0 -28.12148 z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.dc93d0b5a3d4570670b4a232f5a0ccb2.svg";
export { ForwardRef as ReactComponent };